module.exports = __webpack_public_path__ + "static/img/jiaofaPro.60e0575.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/jiaofaPro.png
// module id = bKOF
// module chunks = 1